import { RigContractBase } from './base/rig-contract-base';

export class RigContract extends RigContractBase { }